<template>
  <div class="courseListPage">
      <div class="courseContent" ref="courseContent" >
        <p class="main-text wow animate__animated animate__slideInDown" data-aos="fade-down">欢迎来到哇一 <span>👋</span></p>
        <h1><mark>Welcome to</mark> <span v-if="dataSource[currentIndex]"> {{dataSource[currentIndex].courseName}}</span> </h1>
      </div>
      <!-- <div class="displayCenter" style="margin-bottom:36px">
        <j-dict-select-tag
          :defaultShowAll="true"
          type="radioButton"
          @change="handleChangeType"
          v-model="courseType"
          :trigger-change="true"
          dictCode="course_type"
        />
      </div> -->
      <div class="carousel-container" :style="{'height': elementHeight }" @mousedown="handleMouseDown" @mouseup="handleMouseUp" @mouseleave="handleMouseUp">
        <!-- 左箭头 -->
        <div class="arrow left-arrow" @click="moveCarousel(-1)">&#10094;</div>

        <!-- 图片容器 -->
        <div class="carousel">
          <div v-for="(item, index) in dataSource" :key="index" class="course-item" :class="{ active: getOffset(index) === 0 }" :style="getItemStyle(index, item)" @click="toDetail(item.id)">
            <div v-if="getOffset(index) !== 0" class="showBox"></div>
            <div v-else class="showActiveBox">{{ item.courseName }}</div>
          </div>
        </div>

        <!-- 右箭头 -->
        <div class="arrow right-arrow" @click="moveCarousel(1)">&#10095;</div>
      </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
export default {
  name: "Carousel",
  mixins:[mixinDevice],
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      currentIndex: 0,
      dataSource: [],
      autoRotateInterval: null,
      loading:false,
      isDragging: false,
      startX: 0, // 新增，用于记录鼠标按下时的 X 坐标
      isTriggered: false, // 新增，用于跟踪是否已经触发了切换
      swiperOptionsCourse:{
            autoplay:false,
            speed: 800,
            observer: true,
            observeParents: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            loop: true,
      },
      courseType:'',
       // 分辨率
      windowWidth: window.innerWidth,
      elementHeight:`calc(100vh - 330px)`,
    };
  },
  created() {
    this.getCourseList();
  },
  mounted() {
     window.addEventListener("resize", this.handleResize);
    // this.startAutoRotate(); // 组件挂载时启动自动轮播
  },
  watch: {
    windowWidth:{
      handler(newWidth) {
        // console.log("宽度变化:", newWidth);
      },
      immediate:true
    }
  },
  beforeDestroy() {
     window.removeEventListener("resize", this.handleResize);
    // this.stopAutoRotate(); // 组件销毁时清除定时器，避免内存泄漏
  },
  beforeRouteEnter(to, from, next) {
    // 页面进入时重新加载数据或恢复轮播状态
    next();
  },
  methods: {
    handleResize() {
      // this.windowWidth = window.innerWidth;
      if (this.$refs.courseContent) {
        let height = (this.$refs.courseContent.offsetHeight + 120 ) + 'px'
        this.elementHeight = `calc(100vh - ${height})`;
        console.log(this.elementHeight , 'this.elementHeight')
      }
    },
    handleChangeType(v){
      this.courseType = v.target.value
      this.getCourseList()
    },
    handleMouseDown(event) {
      if (event.button === 0) { // 确保是左键点击
        this.isDragging = true;
        this.startX = event.clientX;
        this.isTriggered = false; // 重置触发标志
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
      }
    },
    handleMouseMove(event) {
      if (this.isDragging) {
        const deltaX = event.clientX - this.startX;
        const threshold = 50; // 定义触发切换的阈值
        if (Math.abs(deltaX) >= threshold && !this.isTriggered) {
          this.isTriggered = true; // 设置触发标志为 true
          this.moveCarousel(deltaX > 0 ? 1 : -1); // 根据 X 坐标变化量决定切换方向
          this.isDragging = false; // 停止拖拽状态
          document.removeEventListener('mousemove', this.handleMouseMove);
        }
      }
    },
    handleMouseUp() {
      this.isDragging = false;
      if (!this.isTriggered) {
        // 如果在鼠标松开时还没有触发过切换，则认为是点击而不是滑动
        this.moveCarousel(0);
      }
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    },
    getCourseList() {
      this.dataSource = [];
      getAction("/teaching/teachingCourse/showCourse", {
        courseType: this.courseType,
        pageSize: 999,
        //  isShow:1
      }).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          for(let i=0;i<this.dataSource.length;i++){
            this.getItemStyle(i,this.dataSource[i])
          }
        }
      });
      // }
    },
    updateCarousel() {
      this.$nextTick(() => {
        // 强制计算位置
        this.getItemStyle(this.currentIndex,this.dataSource[this.currentIndex]); // 强制调用样式更新
      });
    },
    // 获取元素的偏移值
    getOffset(index) {
      const total = this.dataSource.length;
      return (index - this.currentIndex + total) % total;
    },
    toDetail(id) {
      this.$router.push({
        path: "/course/detail",
        query: {
          id: id,
        },
      });
    },
    // 根据偏移量动态计算样式
    getItemStyle(index, item) {
      const offset = this.getOffset(index);
      const baseTransform = "translate(-50%, -50%) scale(1)";
      const style = {
        transition: "transform 0.5s ease-in-out",
        backgroundImage: `url(${item.courseCover_url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        zIndex: "1",
        transform: baseTransform,
      };

      if (offset === 0) {
        style.transform = `translate(-50%, -50%) scale(1)`;
        style.zIndex = "99";
      } else if (offset === 1) {
        style.transform = `translate(20%, -40%) scale(1) rotate(35deg)`;
        style.zIndex = "88";
      } else if (offset === 2) {
        style.transform = `translate(80%, -5%) scale(1) rotate(60deg)`;
        style.zIndex = "77";
      }else if (offset === 3) {
        style.transform = `translate(105%, 60%) scale(1) rotate(96deg)`;
        style.zIndex = "66";
      }else if (offset === 4) {
        style.transform = `translate(-167%, 150%) scale(0) rotate(-125deg)`;
        style.zIndex = "-1";
      } else if (offset === this.dataSource.length - 1) {
        style.transform = `translate(-120%, -40%) scale(1) rotate(-35deg)`;
        style.zIndex = "88";
      } else if (offset === this.dataSource.length - 2) {
        style.transform = `translate(-180%, -5%) scale(1) rotate(-60deg)`;
        style.zIndex = "77";
      }else if (offset === this.dataSource.length - 3) {
        style.transform = `translate(-210%, 50%) scale(1) rotate(-110deg)`;
        style.zIndex = "66";
      }else if (offset === this.dataSource.length - 4) {
        style.transform = `translate(68%, 150%) scale(1) rotate(125deg)`;
        style.zIndex = "-1";
      } else {
        style.transform = `translate(-50%, -50%) scale(0)`;
      }

      return style;
    },

    // 切换轮播
    moveCarousel(direction) {
      const total = this.dataSource.length;
      this.currentIndex = (this.currentIndex + direction + total) % total;
    },
    startAutoRotate() {
      this.autoRotateInterval = setInterval(() => {
        this.moveCarousel(1); // 每次向右移动一张图片
      }, 3000); // 轮播间隔时间（3000ms = 3秒）
    },

    // 停止自动轮播
    stopAutoRotate() {
      clearInterval(this.autoRotateInterval);
    },
  },
};
</script>

<style lang="less" scoped>
.displayCenter{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.courseListPage{
  width: 100%;
  height: 100%;
  background-image: url('~@/theme/wayi/assets/imgs/course/background.png');
  background-size: 100% 100%;
  background-repeat:repeat-y;
}
.mobile{
  .courseContent{
    width: 100%;
    height: auto;
    font-size: 24px;
    
    .main-text{
      margin-bottom: 15px;
    }
    h1{
      font-size: 32px;
    }
  }
  .courserSwiper{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% auto;
    .js_tips{
      width: 100%;
      height: 100%;
      background: #00000062;
      font-size: 28px;
      text-align: center;
      line-height: 100px;
      font-weight: bold;
      color: #fff;
    }
  }
}
.main-text {
    color: #fff;
    text-align: center;
    font-family: "DM Sans", sans-serif;
    font-size: 36px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-top: 50px;
    margin-bottom: 0 !important;
}
.main-text span {
    transform-origin: 70% 70%;
    display: inline-block;
    animation-name: wave-animation;
    animation-duration: 2.5s;
    animation-iteration-count: infinite;
}
.courseContent h1 {
    text-align: center;
    font-family: "DM Sans", sans-serif;
    font-size: 86px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #fff;
    margin-bottom: 43px !important;
}
 mark {
    padding: 0;
    background: var(--13, linear-gradient(90deg, #FF7D61 0%, #FFDB59 100%));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-animation: hue 10s infinite linear;
}
.courseContent{
  width: 100%;
  height: auto;
 
  // padding-top: 69px;
  // padding-top: 69px;
}
/* 全局样式 */
.carousel-container {
  position: relative;
  width: 1200px;
  // height: calc(100vh - 332px);
  // min-height: 540px;
  // max-height: 650px;
  overflow: hidden;
  margin: 0 auto;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.course-item {
  position: absolute;
  width: 220px;
  height: 350px;
  top: 45%;
  left: 50%;
  border-radius: 10px;
  transition: all 0.5s ease-in-out;
  border-radius: 10px;
  filter: grayscale(100%);
  cursor: pointer;
  overflow: hidden;
}

.course-item .showBox {
  width: 100%;
  height: 100%;
  background: #0000005b;
  position: absolute;
  top: 0;
  left: 0;
}

.course-item.active {
  width: 280px;
  height: 400px;
  filter: grayscale(0%);
}

.course-item .showActiveBox {
  width: 100%;
  height: 140px;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  background: linear-gradient(to top, #000, transparent);
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 140px;
}

/* 箭头按钮 */
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  user-select: none;
  z-index: 3;
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
}
@media only screen and (min-width: 1920px){
   .courseContent h1{
    font-size: 86px;
  }
   .carousel-container{
    width: 100%;
    max-width: 1200px;
  }
  .course-item {
    width: 220px;
    height: 350px;
  }
  .course-item.active {
    width: 280px;
    height: 400px;
  }
}
@media only screen and (min-width: 1801px) and (max-width: 1920px) {
  .courseContent h1{
    font-size: 86px;
  }
   .carousel-container{
    width: 100%;
    max-width: 1200px;
  }
  .course-item {
    width: 220px;
    height: 350px;
  }
  .course-item.active {
    width: 280px;
    height: 400px;
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1800px) {
 .courseContent h1{
    font-size: 56px;
  }
  .carousel-container{
    width: 100%;
    max-width: 1200px;
  }
  .course-item {
    width: 190px;
    height: 285px;
  }
  .course-item.active {
    width: 220px;
    height: 350px;
  }
}
@media only screen and (min-width: 1401px) and (max-width: 1600px) {
 .courseContent h1{
    font-size: 46px;
  }
  .carousel-container{
    width: 100%;
    max-width: 1200px;
  }
  .course-item {
    width: 190px;
    height: 285px;
  }
  .course-item.active {
    width: 220px;
    height: 350px;
  }
}
@media only screen and (min-width: 1201px) and (max-width: 1400px) {
 .courseContent h1{
    font-size: 36px;
  }
  .carousel-container{
    width: 100%;
  }
  .course-item {
    width: 160px;
    height: 245px;
  }
  .course-item.active {
    width: 180px;
    height: 250px;
  }
}
@media only screen and (min-width: 781px) and (max-width: 1200px) {
 .courseContent h1{
    font-size: 36px;
  }
  .carousel-container{
    width: 100%;
  }
  .course-item {
    width: 120px;
    height: 185px;
  }
  .course-item.active {
    width: 140px;
    height: 210px;
  }
}
@media only screen and (max-width: 780px) {
  .courseContent h1{
    font-size: 36px;
  }
  .carousel-container{
    width: 100%;
  }
  .course-item {
    width: 120px;
    height: 180px;
  }
  .course-item.active {
    width: 140px;
    height: 200px;
  }
}
</style>
